import { isNewSince } from "../data/notifications";
import Markdown from "./Markdown";
import Panel from "./Panel";
import { LoadingCards } from "./Status";
import ui from "./ui.module.css";

const formatWhen = (iso) => {
  const date = new Date(iso);
  if (!iso || Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
};

// `seenBefore` is when the teacher last opened this list, captured on open,
// so new items stay marked while the panel is showing.
const NotificationsPanel = ({ notifications, seenBefore, onClose }) => {
  const { status, items } = notifications;

  return (
    <Panel title="Notifications" onClose={onClose}>
      {status === "loading" && (
        <LoadingCards label="Loading notifications…" count={2} />
      )}
      {status === "error" && (
        <p>Notifications aren't available right now. Please try again later.</p>
      )}
      {status === "ready" && items.length === 0 && <p>No notifications yet.</p>}
      {items.length > 0 && (
        <ul className={ui.panelList}>
          {items.map((item) => {
            const isNew = isNewSince(item, seenBefore);
            const when = formatWhen(item.receivedAt);
            return (
              <li
                key={item.id}
                className={`${ui.card} ${isNew ? ui.unread : ""}`}
              >
                <div className={ui.row}>
                  <h3>{item.subject}</h3>
                  {isNew && <span className={ui.pill}>New</span>}
                </div>
                {when && <p className={ui.meta}>{when}</p>}
                <Markdown className={ui.content}>{item.message}</Markdown>
              </li>
            );
          })}
        </ul>
      )}
    </Panel>
  );
};

export default NotificationsPanel;
